/**
 * CORE-2114 — `NetworkError: A network error occurred.` без стека.
 *
 * GlitchTip frontend 174 (прод, 05.11.2026): 5 событий за 10 минут, все —
 * Chrome 125 / Windows на `/practices?utm_source=dzen…`. По AnalyticsEvents это
 * 5 сессий с 5 адресов хостинга (AS61178, 79.137.x.x), по одной странице раз в
 * ~5 минут — автомат, проверяющий ссылку из рекламы, а не люди. API у него
 * отвечал 200 (в хлебных крошках — healthz и Region).
 *
 * Что это за отказ: DOMException с кодом 19 (NETWORK_ERR) пришёл в
 * `onunhandledrejection` без единого кадра — промис отверг сам браузер, а не
 * наш код. Наши сетевые отказы выглядят иначе: `fetch` бросает `TypeError`
 * («Failed to fetch» / «Load failed» / «NetworkError when attempting to
 * fetch resource.») со стеком из бандла и разбирается в api.ts. Голый
 * DOMException с таким текстом в Chrome дают загрузки, которые браузер делает
 * сам (шрифт `FontFace`, скрипт service worker), когда окружение их режет, —
 * типично для headless-проверялок. Сделать с ним нечего, а приходит он
 * пачками, поэтому не отправляем.
 *
 * Признак узкий: точный текст, механизм `onunhandledrejection`, ни одного
 * кадра. Тот же текст со стеком (если когда-то бросим его сами) — проходит.
 */

interface ExceptionLike {
  type?: string;
  value?: string;
  mechanism?: { type?: string };
  stacktrace?: { frames?: unknown[] };
}

const BARE_NETWORK_ERROR = /^(NetworkError: )?A network error occurred\.?$/;

export function isBareDomNetworkErrorEvent(event: unknown): boolean {
  const values = (event as { exception?: { values?: ExceptionLike[] } } | null)?.exception?.values;
  if (!Array.isArray(values) || values.length !== 1) return false;
  const ex = values[0];
  if (!BARE_NETWORK_ERROR.test(ex?.value ?? '')) return false;
  if (!/onunhandledrejection/.test(ex?.mechanism?.type ?? '')) return false;
  const frames = ex?.stacktrace?.frames;
  return !Array.isArray(frames) || frames.length === 0;
}

/** `beforeSend` step: `null` for {@link isBareDomNetworkErrorEvent}, else the event. */
export function dropBareDomNetworkError<T>(event: T): T | null {
  if (event === null) return null;
  return isBareDomNetworkErrorEvent(event) ? null : event;
}
